<template>
  <nav>
    <ul class="navlist">
      <li 
        v-for="group in groups" 
        :key="group.label"
        class="navlist__item">
        <el-dropdown @command="handleNavigation">
          <span class="el-dropdown-link">{{ group.label }}</span>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="route in group.routes" :key="route.label" :command="route">
              {{ route.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
      <li class="navlist__item">
        <a href="#" @click.prevent="handleLogout">Logout</a>
      </li>
    </ul>
  </nav>
</template>

<script>
  import axios, { RepositoryError } from '../../repositories';
  import { mapGetters, mapState } from 'vuex';
  import groups from '../../router/groups';

  export default {
    name: 'Nav',
    methods: {
      handleNavigation(route) {
        if (route.external) {
          window.open(route.href || route.to, '_blank', 'noopener,noreferrer');
        } else {
          this.$router.push(route.to).catch(() => {});
        }
      },
      filterRoute(route) {
        return (
          route.permissions === undefined ||
          this.hasPermissionsTo(route.permissions)
        );
      },
      filterGroup(group) {
        const hasPermission = (
          group.permissions === undefined || 
          this.hasPermissionsTo(group.permissions)
        );

        return group.routes.length > 0 && hasPermission;
      },
      async handleLogout() {
        try {
          const csrfToken = document.head.querySelector('meta[name="csrf-token"]')?.content || '';
          await fetch('/logout', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'X-CSRF-TOKEN': csrfToken,
              'Accept': 'application/json',
            },
          });

          if (localStorage) {
            localStorage.removeItem('access_token');
          }

          window.location.href = '/home';
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }
          
          throw err;
        }
      },
    },
    computed: {
      ...mapGetters("auth", ["hasPermissionsTo"]),
      ...mapState({ auth: state => state.auth }),
      groups() {
        return groups.map(group => ({
          ...group,
          routes: group.routes.filter(route => this.filterRoute(route)),
        }))
        .filter(this.filterGroup);
      },
    },
  }
</script>

<style scoped>
  .navlist {
    display: flex;
    list-style: none;
    margin-top: 12px;
    margin-bottom: 0;
    padding-left: 0;
  }

  .navlist__item {
    margin-left: 16px;
    margin-right: 16px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #EEE;
    font-size: 16px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
